import { render, staticRenderFns } from "./OrgRetainedByDay.vue?vue&type=template&id=0a2acc4d&scoped=true&"
import script from "./OrgRetainedByDay.vue?vue&type=script&lang=js&"
export * from "./OrgRetainedByDay.vue?vue&type=script&lang=js&"
import style0 from "./OrgRetainedByDay.vue?vue&type=style&index=0&id=0a2acc4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2acc4d",
  null
  
)

export default component.exports